import { paths } from 'src/routes/paths';
import packageJson from '../package.json';

const ENV = import.meta.env;
const isProd = ENV.PROD;

export const CONFIG = {
  appName: 'Pickle Loop Admin',
  appVersion: packageJson.version,
  appEnv: ENV.VITE_APP_ENV || (isProd ? 'production' : 'development'),
  isStaging: ENV.VITE_APP_ENV === 'staging',
  serverUrl: ENV.VITE_SERVER_URL || (isProd ? 'https://api.pickleloop.app' : 'http://localhost:3000'),
  socketUrl: ENV.VITE_SOCKET_URL || (isProd ? 'https://api.pickleloop.app' : 'http://localhost:3000'),
  assetsDir: ENV.VITE_ASSETS_DIR || '',
  isStaticExport: JSON.parse(ENV.VITE_BUILD_STATIC_EXPORT || 'false'),
  /**
   * Auth
   * @method jwt
   */
  auth: {
    method: 'jwt',
    skip: false,
    redirectPath: paths.dashboard.root,
  },
  
  
  mapboxApiKey: ENV.VITE_MAPBOX_API_KEY || '',
  googleMapsApiKey: ENV.VITE_GOOGLE_MAPS_API_KEY || '',
  
  firebase: {
    apiKey: ENV.VITE_FIREBASE_API_KEY || '',
    authDomain: ENV.VITE_FIREBASE_AUTH_DOMAIN || '',
    projectId: ENV.VITE_FIREBASE_PROJECT_ID || '',
    storageBucket: ENV.VITE_FIREBASE_STORAGE_BUCKET || '',
    messagingSenderId: ENV.VITE_FIREBASE_MESSAGING_SENDER_ID || '',
    appId: ENV.VITE_FIREBASE_APP_ID || '',
    vapidKey: ENV.VITE_FIREBASE_VAPID_KEY || '',
  },
};
